import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const styles = theme => ({
    paper: {
        minWidth: 430,
        overflow: 'visible'
    },
    doublePaper: {
        minWidth: 830,
        overflow: 'visible'
    },
    dialogContent: {
        overflow: 'visible'
    }
});

class CreateModal extends React.Component {
    render() {
        const { classes, open, title, closeHandler, saveHandler, children, helpText, doubleWidth } = this.props;
        return (
            <Dialog classes={{ paper: (doubleWidth ? classes.doublePaper : classes.paper) }} open={open} onClose={closeHandler} aria-labelledby="form-dialog-title" >
                <DialogTitle id="form-dialog-title">{title}</DialogTitle>
                <DialogContent classes={{ root: classes.dialogContent }}>
                    {
                        helpText && 
                        <DialogContentText>
                            {helpText}
                        </DialogContentText>
                    }
                    {children}
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeHandler} color="default">Cancel</Button>
                    <Button onClick={saveHandler} color="secondary">Save</Button>
                </DialogActions>
            </Dialog>
        )
    }
}

CreateModal.propTypes = {
    classes: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    closeHandler: PropTypes.func.isRequired
}

export default withStyles(styles, { withTheme: true })(CreateModal);


// WEBPACK FOOTER //
// ./src/Components/Presentation/_Shared/CreateModal.js